import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum DISABILITIES {
  'Autism' = 1,
  'Depression or anxiety' = 2,
  'Autoimmune disorder' = 3,
  'Diabetes' = 4,
  'Blind or low vision' = 5,
  'Epilepsy' = 6,
  'Cancer' = 7,
  'Gastrointestinal disorders' = 8,
  'Cardiovascular or heart disease' = 9,
  'Intellectual disability' = 10,
  'Celiac disease' = 11,
  'Missing limbs or partially missing limbs' = 12,
  'Cerebral palsy' = 13,
  'Nervous system condition' = 14,
  'Deaf or hard of hearing' = 15,
  'Psychiatric condition' = 16,
}

export const DISABILITIES_DROPDOWN: IDropdown<string>[] = Object.values(DISABILITIES)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${DISABILITIES[value]}`, label: value } as IDropdown<string>));
